// extracted by mini-css-extract-plugin
export default {"img1":"SupportToCauseItem_img1__A6Jm9","img1Background":"SupportToCauseItem_img1Background__Zf60y","logoFotoO":"SupportToCauseItem_logoFotoO__FAXwK"};